import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const MainSolicitud = WithErrorBoundary(
  'Solicitud',
  'Error en Solicitud',
  React.lazy(() => import('./MainSolicitud')),
)

export default {
  path: '/solicitud-venta',
  name: 'Solicitud',
  childRoutes: [
    { path: '', name: 'Main Solicitud', component: MainSolicitud },
  ],
}
